import { SerializePayload } from 'app/area/search-filters/types';
import { filterId } from './constants';
import { CompanyReportsSearchModel } from './types-store';

const serializeQuery = (query: string) =>
  query?.trim().length
    ? {
      [filterId.query]: {
        text: query.trim()
      }
    }
    : {};

export const serialize = (payload: SerializePayload): CompanyReportsSearchModel => serializeQuery(payload.query);
